import { parseTemplate } from 'url-template';
import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import camelcase from 'camelcase';

export function parseUrlParams(
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
  const { url = '', urlParams = {} } = config;

  return {
    ...config,
    url: parseTemplate(url).expand(urlParams),
  };
}

type Error = {
  message: string;
  key?: string;
};

type ResponseObject = { [key: string]: string };

export function parseErrorMessages(error: AxiosError) {
  const errors: Error[] = [];

  if (error.response && error.response.data) {
    if (Array.isArray(error.response?.data)) {
      error.response?.data.map((message) => {
        errors.push({
          message,
        });
      });

      return Promise.reject<AxiosError>({
        ...error,
        response: { ...error.response, data: errors },
      });
    }

    if (typeof error.response?.data === 'string') {
      errors.push({
        message: error.response?.data,
      });

      return Promise.reject<AxiosError>({
        ...error,
        response: { ...error.response, data: errors },
      });
    }

    if (
      typeof error.response?.data === 'object' &&
      'code' in error.response.data &&
      'message' in error.response.data
    ) {
      errors.push(error.response.data as Error);

      return Promise.reject<AxiosError>({
        ...error,
        response: { ...error.response, data: errors },
      });
    }

    Object.entries<string>(error.response?.data as ResponseObject).map(
      ([responseKey, value]) => {
        let key = responseKey;
        let message = value;

        if (Array.isArray(value)) {
          [message] = value;
        }

        if (responseKey.includes('.')) {
          key = responseKey.split('.')[1];
        }

        errors.push({
          key: camelcase(key),
          message,
        });
      }
    );
  }

  return Promise.reject<AxiosError>({
    ...error,
    response: { ...error.response, data: errors },
  });
}
